// extracted by mini-css-extract-plugin
module.exports = {"active":"NavItem_active__CNSou"};